import { render, staticRenderFns } from "./StyleFilterSection.vue?vue&type=template&id=23040e80&"
import script from "./StyleFilterSection.vue?vue&type=script&lang=js&"
export * from "./StyleFilterSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports